const { BASE_URL } = window._CONFIG;

export default {
  login: `${BASE_URL}/login/loginBack`,
  showCode: `${BASE_URL}/login/showCode`,
  findUserByActivationCode: `${BASE_URL}/common/findUserByActivationCode`, // 通过激活码查询用户名邮箱
  findUserByRxUserName: `${BASE_URL}/common/findUserByRxUserName`, // 通过日训用户名查询用户名邮箱
  unbundling: `${BASE_URL}/account/unbundling`, // 解绑日语训练营
  getActivateBookList: `${BASE_URL}/book/getActivateBookList`, // 获取激活图书列表
  getGwActivateBookList: `${BASE_URL}/book/getGwActivateBookList`, // 获取激活图书列表
  getBookUnitLessonList: `${BASE_URL}/book/getBookUnitLessonList`, // 获取书籍单元课程列表
  getGwBookUnitLessonList: `${BASE_URL}/book/getGwBookUnitLessonList`, // 获取书籍单元课程列表
  getGwBookExercisesList: `${BASE_URL}/book/getGwBookExercisesList`, // 获取书籍单元课程列表
  getBookExercisesList: `${BASE_URL}/book/getBookExercisesList`, // 获取激活书籍课件课程练习题
  activeBook: `${BASE_URL}/book/activeBook`, // 激活图书
  resetActivationCode: `${BASE_URL}/book/resetActivationCode`, // 重新激活
  queryCode: `${BASE_URL}/common/qureryCode`, // 查询激活码
};
